var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keySpace"},[_vm._v(" 特色空间 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }